import { LazyAction, LazyModule, LazyImport } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "SearchActions" */ './lazyIndex')
);

export let lazyLoadSearchTable = new LazyAction(lazyModule, m => m.loadSearchTable);

export let lazyCleanSearchTableState = new LazyAction(lazyModule, m => m.cleanSearchTableState)
    .importAndExecute;

export let lazyLoadMoreFindItemSearch = new LazyImport(lazyModule, m => m.loadMoreFindItemSearch);
export let lazyLoadMoreSubstrateSearch = new LazyImport(lazyModule, m => m.loadMoreSubstrateSearch);

export { OnInitialTableLoadComplete } from 'owa-mail-loading-action-types';
export { default as ExecuteSearchResponseMessage } from 'owa-service/lib/contract/ExecuteSearchResponseMessage';
export { TableView } from 'owa-mail-list-store';
export { PerformanceDatapoint } from 'owa-analytics';
export { ActionDatapoint } from 'owa-analytics';
export { LoadSearchTableState } from './actions/loadSearchTable';
export { CleanSearchTableState } from './actions/cleanSearchTableState';
